import { IShift } from '../../features/shifts/shiftsSlice'
import React from 'react'

export const ShiftsPerDayContext = React.createContext<IShift[] | undefined>(undefined)
